import React from "react";
import PropTypes from "prop-types";
import { CardHeader, CircularProgress } from "material-ui";
import { gql, graphql } from "react-apollo";

import SalesReport from "./SalesReport";

const SalesReportQuery = gql`
  query SalesReportRenderer_Trips_Query {
    rawTrips {
      edges {
        node {
          id
          created
          cancelled
          prospect
          specificDates
          segments {
            booked
            cancelled
            bookedTimestamp
            cancelledTimestamp
          }
          cancelledTimestamp
          inbox
          travelStartDate
          tripName
          ownerName
        }
      }
    }
  }
`;

const SalesReportRenderer = ({ data }) => {
  if (data.loading) {
    return (
      <div style={styles.progressContainer}>
        <CardHeader title="Sales Report Loading" />
        <CircularProgress style={styles.progressIndicator} />
      </div>
    );
  }

  const {
    rawTrips: { edges: trips },
  } = data;

  return <SalesReport trips={trips.map(({ node }) => node)} />;
};

SalesReportRenderer.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default graphql(SalesReportQuery)(SalesReportRenderer);

const styles = {
  progressContainer: {
    margin: 10,
    position: "relative",
  },
  progressIndicator: {
    marginLeft: "50%",
    left: -20,
  },
};



// WEBPACK FOOTER //
// /src/components/Reports/Sales/SalesReportRenderer.js